// T56 (Pengecualian 5, 26 Okt 2026) — Ubah jabatan di User Management. Logika MURNI dialog, cermin aturan
// cakupan backend `routers/users._validate_scope`:
//   - WHITELIST_NO_SCOPE_ROLES (Owner, Desainer, SPV Desainer, Admin Purchasing, Finance): tanpa region + toko;
//   - KEPALA_CABANG: region saja;
//   - sisanya (CS, Admin Produksi, Admin Gudang): region + toko di region itu.
// Backend tetap penentu; cermin ini supaya Owner tidak ditawari isian yang pasti ditolak.
import { WHITELIST_NO_SCOPE_ROLES } from "./roles";

const NO_SCOPE = new Set(WHITELIST_NO_SCOPE_ROLES);

export function cakupanPeran(roleCode) {
  if (!roleCode || NO_SCOPE.has(roleCode)) return "TANPA";
  if (roleCode === "KEPALA_CABANG") return "REGION";
  return "TOKO";
}

export function isianLengkap(d) {
  const c = cakupanPeran(d.role_code);
  if (!d.role_code) return false;
  if (c === "REGION") return !!d.region_id;
  if (c === "TOKO") return !!d.region_id && !!d.store_id;
  return true;
}

// Badan PATCH /api/users/whitelist/{id}. Region/toko yang tidak berlaku untuk peran baru dikosongkan EKSPLISIT
// (set_*_null) — tanpa itu backend memakai nilai lama dan menolak INVALID_SCOPE.
export function badanUbahJabatan(d, row) {
  const c = cakupanPeran(d.role_code);
  const badan = { role_code: d.role_code, is_active: !!d.is_active };
  // T58: nama tampilan hanya dikirim bila berubah (kosong = dikosongkan).
  const nt = (d.nama_tampilan ?? "").trim().replace(/\s+/g, " ");
  if (d.nama_tampilan !== undefined && nt !== ((row && row.nama_tampilan) || "")) badan.nama_tampilan = nt;
  if (c === "TANPA") return { ...badan, set_region_null: true, set_store_null: true };
  if (c === "REGION") return { ...badan, region_id: d.region_id, set_store_null: true };
  return { ...badan, region_id: d.region_id, store_id: d.store_id };
}

function tempat(d, regions, stores) {
  const c = cakupanPeran(d.role_code);
  if (c === "TOKO") return stores.find((s) => s.id === d.store_id)?.name || "";
  if (c === "REGION") return regions.find((r) => r.id === d.region_id)?.name || "";
  return "";
}

// Kalimat konfirmasi sehari-hari (K200), mis. "Ubah jabatan pindah.jabatan@example.com dari Designer Editor menjadi
// CS — Balikpapan? Akun akan diaktifkan."
export function kalimatUbahJabatan(row, d, roles, regions, stores) {
  const nama = (code) => roles.find((r) => r.code === code)?.name || code;
  const lama = nama(row.role?.code);
  const baru = nama(d.role_code);
  const t = tempat(d, regions, stores);
  const tempatLama = row.store?.name || row.region?.name || "";
  const sama = row.role?.code === d.role_code && t === tempatLama;
  let k = sama
    ? `Jabatan ${row.email} tetap ${baru}${t ? ` — ${t}` : ""}.`
    : `Ubah jabatan ${row.email} dari ${lama}${tempatLama ? ` — ${tempatLama}` : ""} menjadi ${baru}${t ? ` — ${t}` : ""}?`;
  if (!!d.is_active !== !!row.is_active) k += d.is_active ? " Akun akan diaktifkan." : " Akun akan dinonaktifkan.";
  return k;
}
